import React, { useState } from 'react'

import { Button, Card, CardContent, CardHeader, LinearProgress, Tooltip } from '@mui/material'
import AddSubAccount from 'features/agencies/components/AddSubAccount'
import AgencyAccountActions from 'features/agencies/components/AgencyAccountActions'
import { useAgencyAccounts } from 'features/agencies/hooks/useAgencyAccounts'
import PlanBadge from 'features/customers/components/PlanBadge'
import { Link } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { SimpleTable } from 'components/table'

const config = [
  {
    title: 'Customer Name',
    render: ({ id, name }) => <Link to={UrlProvider.getUrl('customer', { id, tab: '' })}>{name}</Link>,
  },
  {
    title: 'Website',
    field: 'website',
  },
  {
    title: 'Plan',
    render: ({ plan }) => <PlanBadge name={plan} />,
  },
  {
    title: 'Intent Companies limit',
    render: ({ leads_limit: { current, total } }) => (
      <Tooltip title={`${current} / ${total}`}>
        <div>
          <p>{`${current} / ${total}`}</p>
          <LinearProgress value={(current / total) * 100} variant="determinate" />
        </div>
      </Tooltip>
    ),
  },
  {
    render: ({ id }) => <AgencyAccountActions subAccountId={id} />,
  },
]

type AgencyAccountsProps = {
  leftSlots: number
}

const AgencyAccounts = ({ leftSlots }: AgencyAccountsProps) => {
  const [modal, setModal] = useState(false)

  const { data = [] } = useAgencyAccounts()

  const actions = (
    <Button disabled={leftSlots <= 0} onClick={() => setModal(true)}>
      Add new subaccount
    </Button>
  )

  return (
    <Card>
      <CardHeader action={actions} title="Accounts" />
      <CardContent>
        <SimpleTable config={config} data={data} />
      </CardContent>

      {modal && <AddSubAccount onClose={() => setModal(false)} open />}
    </Card>
  )
}

export default AgencyAccounts
